<template>
  <div class="trainDetail">
    <div class="detail-img">
      <img :src="detailObj" alt="" />
    </div>

    <div class="flex-between">
      <div class="left">
        <div v-show="showinfo">
          <p>姓名：{{ baseObj.name }}</p>
          <p>公司：{{ baseObj.company }}</p>
          <p>联系方式：{{ baseObj.mobile }}</p>
        </div>
      </div>
      <div class="rig">
        <img v-show="showqrCode" :src="imgUrl" alt="" />
      </div>
    </div>
    <div class="detail-btn">
      <van-button @click="savePoster" type="info">生成海报</van-button>
    </div>
    <input type="file" accept="image/*" @change="onUpload($event)" ref="inputFile" style="opacity: 0" />
    <van-tabbar v-model="activeTabbar" active-color="#277FFF" inactive-color="#999999" @change="tabbarChange" class="bar-style">
      <van-tabbar-item name="person" icon="friends-o">员工信息</van-tabbar-item>
      <!-- <van-tabbar-item name="qrCode" icon="qr">更换二维码</van-tabbar-item> -->
      <van-tabbar-item name="tepmlate" icon="notes-o">切换海报</van-tabbar-item>
    </van-tabbar>
    <van-overlay :show="showOverlay" :lock-scroll="false">
      <van-icon @click="closeOverlay" class="close-icon" name="cross" />
      <div class="poster-size">
        <img :src="saveImgUrl" alt="" />
      </div>
    </van-overlay>
    <van-popup v-model="showPerson" position="bottom" class="popup-dialog" @click-overlay="closePopup">
      <p @click="chooseClick(item)" v-for="(item, i) in textList" :key="i">
        {{ item.text }}
      </p>
    </van-popup>
    <!-- 海报模板 -->
    <van-popup v-model="showtemplate" position="bottom" class="popup-dialog popup-list" @click-overlay="closePopup">
      <ul>
        <li v-for="item in templateList" @click="chooseTemplate(item)" :key="item.id" :class="activeId == item.id ? 'activebor' : ''">
          <img :src="item.posterUrl" alt="" class="img-radius" />
        </li>
      </ul>
    </van-popup>
  </div>
</template>
<script>
import { wepostermaterialbaseinfo, uploadFile, trainPosterLink, trainPosterList, getPosterCombineUrl } from "@/server/api.js";
import { Toast } from "vant";
import { addressBar } from "@/utils/public";
export default {
  data() {
    return {
      activeTabbar: "",
      showPerson: false,
      showinfo: true,
      showqrCode: true,
      textList: [],
      showOverlay: false,
      showtemplate: false,
      templateList: [],
      activeId: "",
      saveImgUrl: "",
      detailObj: {},
      baseObj: {},
      infoList: [
        { type: "info", text: "展示" },
        { type: "info", text: "不展示" },
        { type: "info", text: "取消" },
      ],
      qrCodeList: [
        { type: "qrCode", text: "个人企微码" },
        { type: "qrCode", text: "上传二维码" },
        { type: "qrCode", text: "不展示" },
      ],
      imgUrl: "",
      windowurl: window.location.href.split("#")[0] || "http://tm-qw.1000phone.net/trainingCampdetail",
      zsUserId: "",
    };
  },
  async mounted() {
    this.activeId = this.$route.query.id;
    if (localStorage.getItem("token")) {
      this.materList();
      this.detailBase();
    } else {
      addressBar("token", this.windowurl);
    }
  },
  methods: {
    // 基本信息
    detailBase() {
      wepostermaterialbaseinfo().then((res) => {
        this.baseObj = res.data;
        this.getTrainPosterLink();
      });
    },
    // 获取海报报名链接
    getTrainPosterLink() {
      this.zsUserId = JSON.parse(localStorage.getItem("userInfo"))?.zsUserId
        ? JSON.parse(localStorage.getItem("userInfo")).zsUserId
        : JSON.parse(localStorage.getItem("user")).zsUserId;
      trainPosterLink({
        courseId: this.activeId,
        name: this.baseObj.name,
        userId: this.zsUserId,
        mobile: this.baseObj.mobile,
      }).then((res) => {
        if (res.code == "200") {
          this.imgUrl = res.data.qrCodeUrl;
        }
      });
    },
    // 获取所有海报列表
    materList() {
      trainPosterList().then((res) => {
        if (res.code == "200") {
          this.templateList = res.data;
          if (res.data.length) {
            res.data.map((v, i) => {
              if (this.activeId == v.id) {
                this.detailObj = v.posterUrl;
              }
            });
          }
        }
      });
    },
    tabbarChange() {
      if (this.activeTabbar == "tepmlate") {
        this.showtemplate = true;
        return;
      }
      this.showPerson = true;
      if (this.activeTabbar == "person") {
        this.textList = this.infoList;
      } else if (this.activeTabbar == "qrCode") {
        this.textList = this.qrCodeList;
      }
    },
    chooseClick(obj) {
      this.showPerson = false;
      this.activeTabbar = "";
      if (obj.text == "展示") {
        this["show" + obj.type] = true;
      } else if (obj.text == "不展示" && obj.type == "info") {
        this["show" + obj.type] = false;
      } else if (obj.text == "不展示" && obj.type == "qrCode") {
        this.baseObj.qr_code = "";
        this["show" + obj.type] = false;
      } else if (obj.text == "个人企微码") {
        this["show" + obj.type] = true;
        this.detailBase();
      } else if (obj.text == "上传二维码") {
        this.$refs.inputFile.click();
      }
    },
    onUpload(e) {
      let formdata = new FormData();
      formdata.append("filrName", e.target.files[0]);
      uploadFile(formdata).then((res) => {
        this.baseObj.qr_code = res.data.url;
      });
    },
    chooseTemplate(obj) {
      this.activeId = obj.id;
      this.detailObj = obj.posterUrl;
      this.getTrainPosterLink();
    },
    closePopup() {
      this.showQrCode = true;
      this.showPerson = false;
      this.activeTabbar = "";
    },
    savePoster() {
      this.showOverlay = true;
      let params = {
        courseId: this.activeId,
        name: this.showinfo ? this.baseObj.name : "",
        userId: this.showinfo ? this.zsUserId : "",
        mobile: this.showinfo ? this.baseObj.mobile : "",
        qrCode: this.imgUrl,
      };
      getPosterCombineUrl(params).then((res) => {
        if (res.code != "200") return Toast.fail(res.msg);
        this.showOverlay = true;
        this.saveImgUrl = res.data;
      });
    },
    closeOverlay() {
      this.showOverlay = false;
      this.saveImgUrl = "";
    },
  },
};
</script>
<style scoped lang="less">
.trainDetail {
  background: #f6f6f6;
  padding: 0 30px;
  overflow-y: auto;
  .detail-img {
    margin-top: 32px;
    width: 100%;
    height: auto;
    border-radius: 16px 16px 0px 0px;
    overflow-y: auto;
    img {
      width: 100%;
      height: auto;
    }
  }
  .flex-between {
    padding: 20px 25px;
    background: #fff;
    border-radius: 0px 0px 16px 16px;
    margin-top: -10px;
  }
  .left {
    flex: 1;
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    p {
      line-height: 50px;
    }
  }
  .rig {
    width: 148px;
    height: 148px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .detail-btn {
    text-align: center;
    margin: 40px 0 180px;
    button {
      width: 100%;
      height: 80px;
      font-size: 30px;
      border-radius: 40px;
    }
  }
  /deep/.van-tabbar {
    height: 100px;
    box-shadow: 0px -3px 8px 0px rgba(0, 0, 0, 0.1);
  }
  /deep/.van-tabbar-item__icon {
    font-size: 34px;
    color: #333;
  }
  /deep/.van-tabbar-item__text {
    font-size: 20px;
    color: #333;
  }

  .popup-dialog {
    height: 293px;
    p {
      font-size: 24px;
      margin: 0 30px;
      padding: 28px 0;
      text-align: center;
      border-bottom: solid 1px #d8d8d8;
    }
    ul {
      padding: 30px 8px;
      display: flex;
      li {
        width: 106px;
        height: 183px;
        padding: 15px 10px;
        border-radius: 4px;
        margin-left: 20px;
        flex-shrink: 0;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .activebor {
        border: 1px solid #277fff;
      }
    }
  }
  .popup-list {
    height: 250px;
  }
  .close-icon {
    position: fixed;
    top: 9%;
    font-size: 50px;
    color: #fff;
    right: 70px;
  }
  .poster-size {
    text-align: center;
    margin-top: 25%;
    width: 100%;
    height: 1100px;
    overflow: hidden;
    overflow-y: scroll;
    img {
      width: 500px;
      height: auto;
      border-radius: 16px;
    }
  }
  .bar-style {
    .van-tabbar-item {
      font-size: 20px;
    }
    .van-tabbar-item__icon {
      width: 34px;
      height: 34px;
    }
  }
}
</style>
